function initProductSlider() {
  const sections = document.querySelectorAll(".product-slider");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const slider = section.querySelector(".swiper");

    if (!slider) {
      return;
    }

    const prevNavButton = slider.querySelector(".swiper-button-prev");
    const nextNavButton = slider.querySelector(".swiper-button-next");

    let swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: nextNavButton,
        prevEl: prevNavButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: true,
          loop: true,
        },
        992: {
          slidesPerView: 3.9,
          centeredSlides: true,
          loop: true,
        },
      },
    });
  });
}

function initSwiperForRecommendations() {
  const slider = document.querySelector(".custom_product_slider");

  if (!slider) {
    return;
  }

  let swiper = new Swiper(slider, {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
}

function changeProductPrice() {
  const productWidgetSection = document.querySelector(
    ".product__info-bottom-list"
  );

  if (!productWidgetSection) return;

  const quantityInput = productWidgetSection.querySelector(
    'input[name="quantity"]'
  );
  const priceElement = productWidgetSection.querySelector(
    ".price-item--regular"
  );

  const newPriceElement = document.querySelector(
    ".product-info__price-box-new-price"
  );

  if (!quantityInput || !priceElement || !newPriceElement) return;

  const priceBoxLabel = productWidgetSection.querySelector('.product-info__price-box-label');

  const currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active,
    currencyDisplay: "symbol",
  });

  quantityInput.addEventListener("change", () => {
    changePrice();
  });

  quantityInput.addEventListener("input", () => {
    changePrice();
  });

  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        changePrice();
      }
    });
  });

  observer.observe(priceElement, {
    characterData: true,
    childList: true,
    subtree: true,
  });

  function changePrice() {
    const unitPrice = parseFloat(
      priceElement.textContent.replace(/[^0-9\.]/g, "")
    );

    let quantity = parseInt(quantityInput.value);

    if (isNaN(quantity) || quantity < 1) quantity = 1;

    const newPrice = (unitPrice * quantity).toFixed(2);
    newPriceElement.textContent = currencyFormatter.format(newPrice);

    formatBottleText(quantity);
  }

  function formatBottleText(quantity) {
    priceBoxLabel.textContent = quantity === 1 ? `${quantity} bottle` : `${quantity} bottles`;
  }
}

function initReadLessMore() {
  const readMoreButtons = document.querySelectorAll('.custom-team-section-card__info .read-more-btn');

  if(!readMoreButtons.length) {
    return;
  }

  readMoreButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const parentWrapper = button.closest('.text-wrapper');
      const content = parentWrapper.querySelector('.text-content');
      const buttonContent = button.querySelector('span');

      content.classList.toggle('collapsed');
      buttonContent.textContent = content.classList.contains('collapsed') ? 'Read less' : 'Read more';
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initProductSlider();
  initSwiperForRecommendations();
  changeProductPrice();
  initReadLessMore();
});
